import React from 'react'
import {
  Box,
  Container,
  Typography,
  makeStyles,
  ListItem,
  List,
  Button,
} from '@material-ui/core'
import Slider from 'react-slick'
//import Page from 'src/component/Page'

const useStyles = makeStyles((theme) => ({
  dialogBox: {
    padding: '30px',
  },
  walletPage: {
    paddingBottom: '20px',
    position: 'relative',
    zIndex: '9',
    '& h1': {
      fontSize: '70px',
      fontWeight: '400',
      color: '#ffffff',
      marginBottom: '100px',
      marginTop: '100px',
      [theme.breakpoints.down('md')]: {
        fontSize: '40px',
        marginTop: '60px',
        marginBottom: '20px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '30px',
        marginTop: '0px',
        marginBottom: '0px',
      },
    },
    '& p': {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '27px',
      color: '#7f7f7f',

      '& span': {
        color: '#ec0066',
        cursor: 'pointer',
      },
    },
  },
  roadBox: {
    position: 'relative',
    alignItems: 'center',
    '& p': {
      display: 'flex',
      marginBottom: '10px',
      '& h4': {
        backgroundColor: '#26373e',
        display: 'inline-block',
        padding: '5px 10px',
        color: '#fff',
        fontSize: '16px',
      },
      '& label': {
        margin: '0',
        color: '#fff',
        padding: '5px 15px',
        borderRadius: '0px ',
        fontSize: '16px',
      },
    },
    '& div': {
      width: '100%',
      maxWidth: '250px',
      position: 'absolute',
    },
  },
  textboxs: {
    position: 'relative',
    zIndex: '1',
    '& li': {
      position: 'relative',
      paddingLeft: '20px',
      fontSize: '20px',
      color: '#ffffff',
      fontWeight: '400',
      '&::after': {
        content: "''",
        position: 'absolute',
        height: '9px',
        width: '9px',
        backgroundColor: '#fff',
        borderRadius: '50%',
        left: 0,
        top: '14px',
      },
      '@media(max-width:768px)': {
        fontSize: '16px',
      },
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: '100%',
    },
    '& h1': {
      fontSize: '50px',
      fontWeight: '600',
      color: '#f30065',
      [theme.breakpoints.down('lg')]: {
        fontSize: '40px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '30px',
      },
    },
    '& p': {
      fontSize: '19px',
      marginTop: '20px',
      color: '#fff',
    },
  },
  mainbox: {
    backgroundImage: 'url(./images/roadmapimg.png)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: '70px',
    position: 'relative',
    paddingBottom: '80px',
    zIndex: '1',
    '&::after': {
      content: "''",
      zIndex: '-1',
      position: 'absolute',
      width: '100%',
      bottom: '0',
      background: 'rgb(0,0,0)',
      background: '#00000057',
      height: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '70px',
      paddingBottom: '10px',
    },
  },
}))
function RoadMap(props) {
  const classes = useStyles()
  const settings = {
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    className: 'recomended',
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          centerPadding: '20px',
          autoplay: false,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          centerPadding: '20px',
          autoplay: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '20px',
          autoplay: false,
        },
      },
    ],
  }
  return (
    //<Page title="Marketplace for NFTs">
    <Box className={classes.roadmapsec}>
      <Box className={classes.mainbox}>
        <Container maxWidth="lg">
          <Box className={classes.walletPage}>
            <Typography variant="h1" align="center">
              Roadmap
            </Typography>
          </Box>
          <Slider {...settings} className="roadmapslider">
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques1.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques2.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques3.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques4.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques1.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques2.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques3.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques4.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
            <div className="sliderBox">
              <Box className="circle circle1">
                <Button>
                  <img src="images/ques1.png" alt="" width="100%" />
                </Button>
              </Box>
              <div className="timlineBox">
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Character Design, NFT system </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Game design and Testing </ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Partnerships</ListItem>
                  </List>
                </Box>
                <Box className={classes.textboxs}>
                  <List>
                    <ListItem>Fundraising</ListItem>
                  </List>
                </Box>
              </div>
            </div>
          </Slider>
        </Container>
      </Box>
    </Box>
    //</Page>
  )
}

export default RoadMap
